import { makeAutoObservable } from 'mobx';
import { ISaveable } from '../../../../stores/types';
import { ICredentialsStore } from './integration-store';

export interface IRiseCredentials {
};

class RiseCredentialsStore implements ISaveable, ICredentialsStore {
    private _changes: IRiseCredentials = {} as IRiseCredentials;

    constructor() {
        makeAutoObservable(this);
    }

    /** ICredentialsStore implementation ************/
    public async getCredentials() {
        return { ...this._changes };
    }


    /********* ISaveable implementation *************/
    public hasChanges(): boolean {
        return !!Object.keys(this._changes).length;
    }

    public discardChanges(): void {
        this._changes = {} as IRiseCredentials;
    }

    public getUpdatedModel(): IRiseCredentials { throw new Error('Not implemented.'); }
    public isSaving(): boolean { throw new Error('Not implemented.'); }
    public commitChanges() { throw new Error('Not implemented.'); }
    public async save() { throw new Error('Not implemented.'); }
}

export default RiseCredentialsStore;
